import { Box, Flex, Spinner } from '@chakra-ui/react';
import { KModal } from '@/ui-library/components';
import { KText } from '@/ui-library/components/text';
import { SanitizedBox } from '@/ui/SanitizedDom';
import { useCoordinatorTemplateById } from '@/api/ai-coordinator';

/**
 * Preview modal for a coordinator template.
 * When templateId is provided, fetches template body by id (with loader); otherwise uses template.body if present.
 */
export const TemplatePreviewModal = ({
  template,
  templateId,
  name,
  isOpen,
  onClose,
}) => {
  const idToFetch = templateId ?? template?.id ?? null;
  const displayName = name ?? template?.name ?? 'Template';
  const { data, isLoading, isError } = useCoordinatorTemplateById(
    idToFetch,
    !!isOpen && !!idToFetch
  );
  const body = template?.body ?? data?.data?.body ?? null;

  return (
    <KModal
      isOpen={isOpen}
      onClose={onClose}
      title={`Preview of ${displayName}`}
      footer={false}
      size="lg"
    >
      <Box maxH="400px" overflowY="auto">
        {idToFetch && isLoading ? (
          <Flex justify="center" py="24px">
            <Spinner size="md" color="primary-500" />
          </Flex>
        ) : isError ? (
          <KText color="secondary-500">Failed to load template</KText>
        ) : body ? (
          <SanitizedBox html={body} />
        ) : (
          <KText color="secondary-500">No content available</KText>
        )}
      </Box>
    </KModal>
  );
};
